/**
 * Section Types
 * - topic landing page
 *   - How To Guides, Admin, optional pdf embed at top
 * - faq accordians
 * - topic switcher
 * - pdf embed
 * - custom (catchall)
 */

/**
 * Sidebars: Each sidebar lists all the pages and headers
 * Pages: Each page is just the page plus a reference to the sidebar
 */

export const MainSidebar = [
  { type: 'link', title: 'How To Guides', href: '/help/info/how-to' },
  { type: 'link', title: 'Frequently Asked Questions', href: '/help/info/faq' },
  { type: 'link', title: 'Admin', href: '/help/info/admin' },
];

export const TopicSidebars: { [path: string]: HelpModule.SidebarItem[] } = {
  'how-to': [
    { type: 'header', title: 'Getting Started' },
    {
      type: 'link',
      title: 'Getting Started Guide',
      href: '/assets/help/pdfs/Getting Started Guide - CIAO v2.5.pdf',
      icon: 'pdf',
      external: true,
      new: false,
    },
    {
      type: 'link',
      title: 'Guest Login Guide',
      href: '/assets/help/pdfs/CIAO Guest & Dispatcher Login Guide - September 2026.pdf',
      icon: 'pdf',
      external: true,
      new: false,
    },
    {
      type: 'link',
      title: 'Log In with a Personal Device',
      href: '/help/info/how-to/login-personal-device',
    },
    {
      type: 'link',
      title: 'Log In with a Government Device',
      href: '/help/info/how-to/login-government-device',
    },
    {
      type: 'link',
      title: 'Roles & Permissions',
      href: '/help/info/admin/roles-permissions',
      new: true,
    },
    {
      type: 'link',
      title: 'Register and Update Your User Profile',
      href: '/help/info/how-to/register-user-profile',
    },
    { type: 'header', title: 'Trip Management' },
    {
      type: 'link',
      title: 'Join a Team',
      href: '/help/info/how-to/teams-be-added',
    },

    {
      type: 'link',
      title: 'Create a Trip',
      href: '/help/info/how-to/trips-create',
    },
    {
      type: 'link',
      title: 'Edit a Trip',
      href: '/help/info/how-to/trips-edit',
    },
    {
      type: 'link',
      title: 'Change Trip Status',
      href: '/help/info/how-to/trips-check-in-out-okay',
    },
    {
      type: 'link',
      title: 'View a Trip',
      href: '/help/info/how-to/trips-view-log',
    },
    {
      type: 'link',
      title: 'Text and Email Notifications',
      href: '/help/info/how-to/text-notifications',
    },
    {
      type: 'link',
      title: 'Quick Links',
      href: '/help/info/how-to/quick-links',
    },
    { type: 'header', title: 'Related FAQs' },
    {
      type: 'link',
      title: 'How do I create a CIAO user account? ',
      href: '/help/info/faq/create-ciao-user',
    },
    {
      type: 'link',
      title: 'Can team members without a USDA account use CIAO? ',
      href: '/help/info/faq/non-usda-team-members',
    },
  ],
  admin: [
    { type: 'header', title: 'Getting Started' },
    {
      type: 'link',
      title: 'Getting Started Guide',
      href: '/assets/help/pdfs/Getting Started Guide - CIAO v2.5.pdf',
      icon: 'pdf',
      external: true,
      new: false,
    },
    {
      type: 'link',
      title: 'Guest Login Guide',
      href: '/assets/help/pdfs/CIAO Guest & Dispatcher Login Guide - September 2026.pdf',
      icon: 'pdf',
      external: true,
      new: false,
    },
    {
      type: 'link',
      title: 'Roles & Permissions',
      href: '/help/info/admin/roles-permissions',
      new: true,
    },

    { type: 'header', title: 'Management' },
    {
      type: 'link',
      title: 'Add, Edit, or Delete a User',
      href: '/help/info/admin/users-edit-delete',
    },

    {
      type: 'link',
      icon: 'video',
      title: 'Add, Edit, or Delete a Team',
      href: '/help/info/admin/teams-create-edit-delete',
    },
    { type: 'header', title: 'Related FAQs' },
    {
      type: 'link',
      title: 'How do I create a CIAO user account?',
      href: '/help/info/faq/create-ciao-user',
    },
    {
      type: 'link',
      title: 'Can team members without a USDA account use CIAO?',
      href: '/help/info/faq/non-usda-team-members',
    },
  ],
};

export const HelpPages: { [path: string]: HelpModule.HelpPage } = {
  'how-to': {
    title: 'How To Guides',
    type: 'topic/image',
    src: '/assets/help/img/how-to-landing-splash.png',
    alt: 'Decorative Images of a backpack, a video on a monitor, and a printed KBA file.  Text reads: We all learn in different ways.  Some like to explore, others prefer watching videos, and some just want to print it out and read.  We have you covered!',
    description: '',
    // 'Select a topic from the right menu to watch the video or view and print the KBA.',
  },
  admin: {
    title: 'Admin',
    type: 'topic/image',
    src: '/assets/help/img/admin-landing-splash.svg',
    alt: 'Welcome, Admin!  Decorative images of people.  Example Admin One is a System Administrator.  Example Admin Two is a Region or Station Administrator.  Example Admin Three is a Forest or Lab Administrator.',
    description: '',
    // '## Choose a topic to learn more' +
    // '\n\nWe all learn differently, some want to explore, others want to watch a video, and some want to print it out and read it. We have you covered! Choose a topic to watch the video or view and print the KBA.',
  },
  faq: {
    title: 'Frequently Asked Questions',
    type: 'custom/faq',
  },
  'version-history': {
    title: 'Version History',
    type: 'custom/versionHistory',
  },
  'how-to/login-personal-device': {
    title: 'Log In with a Personal Device',
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      '## Log In with a Personal Device' +
      '\n\nAccess CIAO from your personal laptop or mobile device using Login.gov to log in. You can view and/or download the latest Knowledge Based Article (KBA) using the link below.' +
      '\n\n[View How to Login with a Personal Device KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00148926/rkm)',
  },
  'how-to/login-government-device': {
    title: 'Log In with a Government Device',
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      '## Log In with a Government Device' +
      '\n\nAccess CIAO from your Government-issued laptop or mobile device using eAuth to log in. You can view and/or download the latest Knowledge Based Article (KBA) using the link below.' +
      '\n\n[View How to Login with a Government Device KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00142843/rkm)',
  },
  'how-to/register-user-profile': {
    title: 'Register and Update Your User Profile',
    type: 'custom/registerUserProfile',
    // Rendered by RegisterUserProfileComponent; this copy only feeds search.
    description:
      'Registering your CIAO user profile after authenticating through eAuth, ' +
      'USDA email verification, updating your name, admin roles, default ' +
      'supervisor, email addresses, phone numbers and text notifications, ' +
      'clock and time zone, getting added to a team, and becoming an admin or ' +
      'supervisor.',
  },
  'how-to/trips-create': {
    title: 'Create a Trip',
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      '## Create a Trip' +
      '\n\nLearn more about creating a trip in CIAO on the CEC Digital Workplace where you can view and/or download the latest Knowledge Based Article (KBA).' +
      '\n\n[Visit Create a Trip KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00146637/rkm)' +
      '  \n[Visit Duplicate a Trip KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00150725/rkm)',
  },
  'how-to/trips-edit': {
    title: 'Edit a Trip',
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      '## Edit a Trip' +
      '\n\nLearn more about editing, duplicating, or deleting a trip in CIAO on the CEC Digital Workplace where you can view and/or download the latest Knowledge Based Article (KBA).' +
      '\n\n[Visit Edit a Trip KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00150232/rkm)' +
      '  \n[Visit Delete a Trip KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00150334/rkm)' +
      '  \n[Visit Duplicate a Trip KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00150725/rkm)',
  },
  'how-to/trips-check-in-out-okay': {
    title: "Change Trip Status (Check Out, Check In, and I'm Okay)",
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      "## Change Trip Status (Check Out, Check In, and I’m Okay)" +
      "\n\nLearn more about how to check out, check in, and let your team know you\u2019re okay in CIAO on the CEC Digital Workplace where you can view and/or download the latest Knowledge Based Article (KBA). " +
      '\n\n[View "Check Out, Check In, and I\'m Okay" KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00143129/rkm)',
  },
  'how-to/quick-links': {
    title: 'Quick Links',
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      '## Quick Links' +
      '\n\nLearn more about using CIAO Quick Links on the CEC Digital Workplace where you can view and/or download the latest Knowledge Based Article (KBA). ' +
      '\n\n[View Quick links KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00155732/rkm)',
  },

  'how-to/trips-view-log': {
    title: 'View a Trip',
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      '## View a Trip' +
      '\n\nLearn more about how to view trip status and trip logs in CIAO on the CEC Digital Workplace where you can view and/or download the latest Knowledge Based Article (KBA).' +
      '\n\n[Visit the Trip Status and Trip Log KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00142840/rkm)' +
      '  \n[Visit the View a List of Planned Trips KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00150233/rkm)',
  },
  'how-to/text-notifications': {
    title: 'Text and Email Notifications',
    type: 'topic/image',
    src: '/assets/help/vid/email_text_help.png',
    alt: 'Table showing CIAO text and email notification availability by event and recipient. Columns compare Crew Member and Point of Contact notifications via email and text. Trip start sends email to crew members (with QuickLink) and email to points of contact (.gov only), no texts. ‘I’m Okay – Late’ and late trip alerts send text notifications to crew members and points of contact. Submitted ‘I’m Okay’ sends no notifications. Trip end sends email to crew members only.',
    description:
      '## Text and Email Notifications' +
      '\n\nLearn more about text and email notifications in CIAO on the CEC Digital Workplace where you can view and/or download the latest Knowledge Based Article (KBA).' +
      ' \n\n[Visit the Enabling Text Notifications KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00146994/rkm)',
  },

  'how-to/teams-be-added': {
    title: 'Join a Team',
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      '## Join a Team' +
      '\n\nLearn more about how to join a team in CIAO on the CEC Digital Workplace where you can view and/or download the latest Knowledge Based Article (KBA).' +
      '\n\n[Visit the View or Be Added to a Team KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00142755/rkm)',
  },
  // 'teams-roles-permissions': {
  //   title: 'Roles and Permissions Matrix',
  //   type: 'topic/video',
  //   src: '',
  //   alt: '',
  //   poster: '',
  //   description:
  //     '[View the Roles & Permissions Matrix in PDF](/assets/help/pdfs/admin-roles-permissions.pdf)' +
  //     '  \n[Visit the KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00146994/rkm)',
  // },

  // 'roles-permissions-kba': {
  //   title: 'Roles & Permissions',
  //   type: 'externalTopic',
  //   href: 'https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00146910/rkm',
  // },
  'admin/roles-permissions': {
    title: 'Roles & Permissions',
    type: 'custom/rolesPermissions',
  },
  // 'roles-permissions-accessible': {
  //   title: 'Roles & Permissions',
  //   type: 'topic/pdf',
  //   pdfUrl: 'admin-roles-permissions.pdf',
  // },

  'admin/users-edit-delete': {
    title: 'Add, Edit, or Delete a User',
    type: 'topic/video',
    src: '',
    alt: '',
    poster: '',
    description:
      '## Add, Edit, or Delete a User' +
      '\n\nAdmins, learn more about adding, editing, or deleting a CIAO user on the CEC Digital Workplace where you can view and/or download the latest Knowledge Based Article (KBA).' +
      '\n\n[Visit the Add, Edit, or Delete a User KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00147010/rkm)' +
      '  \n[Visit the PDF for Adding a User](/assets/help/pdfs/admin.user.create.pdf)',
  },

  'admin/teams-create-edit-delete': {
    title: 'Add, Edit, or Delete a Team',
    type: 'topic/video',
    src: '/assets/help/vid/admin-managing-teams-dec-6.mp4',
    alt: '',
    poster: '/assets/help/vid/add-delete-team-poster.png',
    description:
      '## Add, Edit, or Delete a Team' +
      '\n\nAdmins, learn how to add, edit, or delete a team in CIAO. Watch a short video tutorial for an overview, view the latest Knowledge Based Article (KBA), or download a PDF for easy viewing.' +
      '\n\n[Visit the Create, Edit, or Delete a Team KBA](https://usdacts-myit.fed.onbmc.com/dwp/app/#/knowledge/KBA00147429/rkm)',
  },
};
